import { render, staticRenderFns } from "./broadcasting.vue?vue&type=template&id=45519355"
import script from "./broadcasting.vue?vue&type=script&lang=js"
export * from "./broadcasting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports